import { Footer, FooterCopyright, FooterLink, FooterLinkGroup } from 'flowbite-react'
import React, { useState } from 'react'
import { FooterMetaProps } from '../../data/types'
import { ViewTermsModal } from './ViewTermsModal'
import { TermsAndConditionsMeta } from '../../data'

type Props = {
    meta: FooterMetaProps
    className?: string
}

export const FooterCustom = (props: Props) => {
    const { meta: { nav: { termsAndCondition, privacyNotice}, version, copyRight }, className = '' } = props
    const [showTermsModal, setShowTermsModal] = useState(false)

    return (
        <>
            <Footer container className={`rounded-none border-t dark:border-gray-700 ${className}`}>
                <FooterCopyright href="#" by={`${copyRight}`} year={version}/>
                <FooterLinkGroup>
                    <FooterLink
                        href="#"
                        onClick={(e) => {
                            e.preventDefault()
                            setShowTermsModal(true)
                        }}
                    >
                        {privacyNotice}
                    </FooterLink>
                </FooterLinkGroup>
            </Footer>

            <ViewTermsModal
                isOpen={showTermsModal}
                onClose={() => setShowTermsModal(false)}
                meta={TermsAndConditionsMeta}
            />
        </>
    )
}

